export const content = {
  agreeAndCreateAccount: 'buttons.poma.base',
  bagHandleText: 'valueProps.passwordlessUpgrade.moreWaysToPayLabel',
  createAccount: 'upgradeInterstitial.createAccount',
  createAccountContinue: 'buttons.poma.continueAsMember',
  createAccountDetails: 'upgradeInterstitial.createAccountDetails',
  emailHelper: 'upgradeInterstitial.emailHelper',
  headerText: 'valueProps.passwordlessUpgrade.headerText',
  paymentSuccessTitle: 'upgradeInterstitial.paymentSuccessTitle',
  pomaSimplified: 'terms.pomaSimplified',
  shieldLockText:
    'valueProps.passwordlessUpgrade.spendAndSendWithConfidenceLabel',
  stampPercentText: 'valueProps.passwordlessUpgrade.saveBigWithGreatDealsLabel',
  stayAsGuest: 'upgradeInterstitial.stayAsGuest',
};
